// @ts-nocheck
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { assignById, setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import StoreListsDataState from "@store/Framework/Store/Data/StoreLists/StoreListsState";
import {
    StoreListCollectionModel,
    StoreListCustomersCollectionModel,
    StoreListModel,
} from "@store/Framework/Types/ApiModels";
import { GetStoreListApiParameter, GetStoreListsApiParameter } from "@store/Services/StoreListService";
import { Draft } from "immer";

const initialState: StoreListsDataState = {
    isLoading: {},
    byId: {},
    dataViews: {},
    errorStatusCodeById: {},
};

const actions = {
    "Data/StoreLists/BeginLoadStoreLists": (
        draft: Draft<StoreListsDataState>,
        action: { parameter: GetStoreListsApiParameter },
    ) => {
        setDataViewLoading(draft, action.parameter);
    },
    "Data/StoreLists/CompleteLoadStoreLists": (
        draft: Draft<StoreListsDataState>,
        action: { parameter: GetStoreListsApiParameter; result: StoreListCollectionModel },
    ) => {
        setDataViewLoaded(draft, action.parameter, action.result, collection => collection.storeListCollection!);
    },
    "Data/StoreLists/BeginLoadStoreList": (draft: Draft<StoreListsDataState>, action: { storeListId: string }) => {
        draft.isLoading[action.storeListId] = true;
    },
    "Data/StoreLists/CompleteLoadStoreList": (
        draft: Draft<StoreListsDataState>,
        action: { storeList: StoreListModel },
    ) => {
        delete draft.isLoading[action.storeList.id];
        assignById(draft, action.storeList);
        if (draft.errorStatusCodeById) {
            delete draft.errorStatusCodeById[action.storeList.id];
        }
    },
    "Data/StoreLists/FailedToLoadStoreList": (
        draft: Draft<StoreListsDataState>,
        action: { storeListId: string; status: number },
    ) => {
        delete draft.isLoading[action.storeListId];
        if (draft.errorStatusCodeById) {
            draft.errorStatusCodeById[action.storeListId] = action.status;
        }
    },
    "Data/StoreLists/Reset": () => {
        return initialState;
    },
    "Data/StoreLists/CompleteLoadStoreListCustomers": (
        draft: Draft<StoreListsDataState>,
        action: { parameter: GetStoreListApiParameter; result: StoreListCustomersCollectionModel },
    ) => {
        if (!draft.byId[action.parameter.storeListId]) {
            return;
        }
        draft.byId[action.parameter.storeListId].customerList = action.result.storeListCustomerCollection;
    },
};

const reducer = createTypedReducerWithImmer(initialState, actions);
export type StoreListsDataActions = Parameters<typeof reducer>[1];
export default reducer;
